<template>
  <v-layout row justify-center class="mt-4">
    <v-flex xs11 sm11 xl11 md11 lg11>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>รายการข้อความที่บรอดแคสต์ทั้งหมด</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <div style="height: calc(100vh - 230px);" id="scrolling-addnews"  class="scrolling-wrapper">
          <!-- v-on:scroll="handleScroll" -->
          <v-progress-linear v-if="loading" v-slot:progress color="blue" indeterminate></v-progress-linear>
          <v-list three-line>
            <v-layout v-if="list_message.length === 0" row wrap justify-center align-center class="mt-3">
              <h3>ไม่มีรายการที่บรอดแคสต์</h3>
            </v-layout>
            <template v-for="item in list_message">
                  <v-list-tile
                    :key="item._id"
                    class="mt-2 mb-3"
                  >
                    <v-list-tile-action class="mt-2" style="display: flex; justify-content: center; align-items: center;">
                      <read-more v-if="item.typeofmessage === 'message'" more-str="อ่านเพิ่มเติม" :text="item.message" less-str="แสดงน้อยลง" :max-chars="10"></read-more>
                      <!-- <span v-if="item.typeofmessage === 'message'">{{ item.message }}</span> -->
                      <img @click="openModal(item)" v-else-if="item.typeofmessage === 'image'" class="mt-1" :src="item.message" alt="" width="80" height="80">
                      <v-icon @click="openModal(item)" v-else-if="item.typeofmessage === 'file' && extension(item.message) === 'fas fa-file-pdf'" color="primary" style="font-size: 30px;">{{extension(item.message)}}</v-icon>
                      <v-icon v-else-if="item.typeofmessage === 'file' && extension(item.message) !== 'fas fa-file-pdf'" color="primary" style="font-size: 30px;">{{extension(item.message)}}</v-icon>
                      <!-- <video  v-else-if="item.typeofmessage === 'video'" style="width: 80px !important; height: 80px !important;" controls disablePictureInPicture controlsList="nodownload noFullscreen">
                        <source :src="item.message" :type="'video/' + item.message.split('.')[item.message.split('.').length - 1]">
                      </video> -->
                      <v-img
                        @click="openModal(item)"
                        v-else-if="item.typeofmessage === 'video'"
                        :src="item.thumbnail"
                        aspect-ratio="1"
                        class="grey lighten-2"
                        style="cursor: pointer; object-fit: contain; object-position: 50% 0;"
                        width="80"
                        height="80"
                      >
                        <template>
                          <v-layout
                            class="fill-height ma-0"
                            justify-center
                            align-center
                            column
                          >
                            <v-icon color="white" style="font-size: 50px;">mdi-play-circle</v-icon>
                          </v-layout>
                        </template>
                      </v-img>
                      <span v-else>-</span>
                      <!-- <v-btn class="mt-1" @click="downloadFile(item)" small flat icon color="black" v-if="item.typeofmessage === 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'video'">
                        <v-icon >mdi-download</v-icon>
                      </v-btn> -->
                    </v-list-tile-action>

                    <v-list-tile-content class="pl-5">
                      <v-list-tile-sub-title class="mt-2">ประเภทข้อความ: {{ item.typeofmessage }}</v-list-tile-sub-title>
                      <v-list-tile-sub-title class="mt-2">ชื่อไฟล์: <read-more v-if="item.file_name" more-str="อ่านเพิ่มเติม" :text="item.file_name" less-str="แสดงน้อยลง" :max-chars="10"></read-more> <span v-else>-</span> </v-list-tile-sub-title>
                      <v-list-tile-sub-title class="mt-1">วันที่ {{dateMoment(item.timestamp)}} เวลา {{ timeMoment(item.timestamp) }} น.</v-list-tile-sub-title>
                      <v-list-tile-sub-title class="mt-1" v-if="status_bot">
                        <span v-if="item.count_read !== 0">คนอ่าน {{ formattotal(item.count_read) }} คน</span>
                        <span v-else>คนอ่าน 0 คน</span>
                      </v-list-tile-sub-title>
                      <v-list-tile-sub-title class="mt-1" v-if="item.typeofmessage === 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'video'">
                        <v-btn class="mt-1" @click="downloadFile(item)" small flat outline round color="primary">
                          <!-- <v-icon>mdi-download</v-icon> -->
                          ดาวน์โหลด
                        </v-btn>
                      </v-list-tile-sub-title>
                    </v-list-tile-content>

                    <v-list-tile-action>
                      <v-layout row wrap justify-center align-center>
                        <v-flex xs6 sm6>
                          <v-btn icon flat v-if="status_bot" :disabled="item.count_read === 0">
                            <v-icon color="black" @click="openDialog(item)" >mdi-dots-horizontal</v-icon>
                          </v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 class="pl-2">
                          <v-btn :disabled="item.typeofmessage !== 'message' && item.typeofmessage !== 'file' && item.typeofmessage !== 'image' && item.typeofmessage !== 'video'" icon @click="unsendmessage(item._id)">
                            <v-icon color="red">fa fa-window-close</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-list-tile-action>
                </v-list-tile>
                <!-- <v-divider
                  v-if="index + 1 < list_message.length"
                  :key="index"
                ></v-divider> -->
            </template>
          </v-list>
          <div class="text-xs-center pt-2" v-if="showbtnload">
            <v-progress-linear v-if="loading_more" v-slot:progress color="blue" indeterminate></v-progress-linear>
            <v-btn color="#3076d2" :loading="loading_more" dark round @click="getListOldBroadcast(list_message[list_message.length - 1].timestamp)">โหลดเพิ่มเติม</v-btn>
          </div>
        </div>
      </v-card>
    </v-flex>
    <Report :ReportDialog="ReportDialog" :count_room="count_room" :listfriend="listfriend" @closeDialog="closeDialog"/>
    <ShowImageDialog :DetailImage="DetailImage" :dialogshowimage="dialogshowimage" @closeDialogShowImage="closeDialogShowImage"/>
  </v-layout>
</template>
<script>
import { Momenttime } from '@/services'
import Report from '@/components/LayoutOnMobile/dialog/ReportUserReadMessage'
import ShowImageDialog from '@/components/LayoutOnMobile/dialog/ShowImageDialog'
var _ = require('lodash')
export default {
  props: {
    tokenbot: String
  },
  components: {
    Report,
    ShowImageDialog
  },
  data () {
    return {
      status_bot: false,
      DetailImage: {},
      dialogshowimage: false,
      showbtnload: false,
      loading_more: false,
      loading: false,
      search: '',
      pagination: {
        sortBy: 'fat'
      },
      selected: [],
      headers: [
        {
          text: 'ข้อความ',
          align: 'center',
          sortable: false,
          value: 'message'
        },
        { text: 'ประเภทข้อความ', value: 'typemessage', sortable: false, align: 'center' },
        { text: 'วัน-เวลาที่บรอดแคสต์', value: 'timestamp', sortable: false, align: 'center' },
        { text: 'ยกเลิกการส่งข้อความ', value: '', sortable: false, align: 'center' }
      ],
      list_message: [],
      count_room: 0,
      ReportDialog: false,
      listfriend: []
    }
  },
  created () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var hour = String(today.getHours()).padStart(2, '0')
    var minute = String(today.getMinutes()).padStart(2, '0')
    var seconds = String(today.getSeconds()).padStart(2, '0')
    var milsec = today.getMilliseconds()
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = yyyy + '-' + mm + '-' + dd + ' ' + hour + ':' + minute + ':' + seconds + '.' + milsec
    // console.log(today)
    this.getListBroadcast(today)
  },
  methods: {
    openModal (item) {
      this.DetailImage = item
      this.dialogshowimage = true
    },
    closeDialogShowImage (value) {
      this.DetailImage = {}
      this.dialogshowimage = value
    },
    downloadFile (item) {
      // console.log(item)
      console.log(this.extension(item.original_file) === 'fas fa-file-video')
      // // this.download = true
      if (this.extension(item.original_file) === 'fas fa-file-video' || this.extension(item.original_file) === 'fas fa-file-audio') {
        this.axios.get(item.original_file, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          var filename = ''
          if (item.file_name !== '') {
            filename = item.file_name
          } else {
            filename = item.message
          }
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          this.download = false
        })
      } else {
        this.axios.get(item.message, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          var filename = ''
          if (item.file_name !== '') {
            filename = item.file_name
          } else {
            filename = item.message
          }
          // link.setAttribute('download', item.file_name)
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          this.download = false
        })
      }
    },
    closeDialog (value) {
      this.ReportDialog = value
    },
    openDialog (item) {
      console.log('open dialog')
      // console.log(item)
      // this.count_room = item.count_room
      this.listfriend = item.read
      this.ReportDialog = true
    },
    formattotal (data) {
      // console.log(data)
      if (data !== null && data !== '' && data !== undefined) {
        return data.toLocaleString('en-US')
      } else {
        return data
      }
    },
    unsendmessage (id) {
      // console.log(id)
      this.$swal({
        type: 'warning',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก',
        text: 'คุณต้องการยกเลิกข้อความบรอดแคสต์นี้ใช่หรือไม่?',
        showCloseButton: true,
        showCancelButton: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.VUE_APP_API_OFFICIAL + `/unsend-broadcast`, {
            bot_id: this.tokenbot,
            tokenmessage: id
          }).then((response) => {
            // console.log(response.data.status)
            var index = _.findIndex(this.list_message, function (o) { return o._id === id })
            this.list_message.splice(index, 1)
            this.$swal({
              type: 'success',
              text: 'ยกเลิกข้อความบรอดแคสต์สำเร็จ',
              confirmButtonText: 'ตกลง'
            })
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        // return 'media'
        return 'fas fa-file-video'
      } else if (audio.includes(extension)) {
        // return 'audio'
        return 'fas fa-file-audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    dateMoment (data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment (data) {
      return Momenttime.momenttimethai(data)
    },
    handleScroll (event) {
      const listElm = document.getElementById('scrolling-addnews')
      // console.log(listElm.scrollTop)
      if ((listElm.scrollTop + listElm.clientHeight) >= (listElm.scrollHeight * 0.5)) {
        // console.log('load news')
        this.getListOldBroadcast(this.list_message[this.list_message.length - 1].timestamp)
      }
    },
    getListBroadcast (time) {
      // console.log(time)
      this.loading = true
      this.axios.post(process.env.VUE_APP_API_OFFICIAL + `/get-list-broadcast`, {
        bot_id: this.tokenbot,
        time: time
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.loading = false
          this.status_bot = response.data.isLimit
          // this.list_message = _.filter(response.data.data, function(o) { return o.typeofmessage === 'message' || o.typeofmessage === 'image' || o.typeofmessage === 'file' || o.typeofmessage === 'video' })
          this.list_message = _.unionBy(response.data.data, '_id')
          if (response.data.data.length === 20) {
            this.showbtnload = true
          } else {
            this.showbtnload = false
          }
        }
        // this.list_message = response.data.data
        // this.list_message.unshift.apply(this.list_message, response.data.data.reverse())
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    getListOldBroadcast (time) {
      // console.log(time)
      this.loading_more = true
      this.axios.post(process.env.VUE_APP_API_OFFICIAL + `/get-list-broadcast`, {
        bot_id: this.tokenbot,
        time: time
      }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.loading_more = false
          // var msg_filter = _.filter(response.data.data, function(o) { return o.typeofmessage === 'message' || o.typeofmessage === 'image' || o.typeofmessage === 'file' || o.typeofmessage === 'video' })
          this.list_message.push.apply(this.list_message, response.data.data)
          this.list_message = _.unionBy(this.list_message, '_id')
          if (response.data.data.length === 20) {
            this.showbtnload = true
          } else {
            this.showbtnload = false
          }
        }
      }).catch(error => {
        this.loading_more = false
        console.log(error)
      })
    }
  }
}
</script>
<style media="screen" scoped>
>>>.v-list--three-line .v-list__tile {
  height: 180px !important;
}
>>>.v-table__overflow {
  width: 100% !important;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  /* height: 500px !important; */
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 6px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
</style>
